import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Collapse } from 'antd';
import { useSelector } from 'react-redux';
function Faq() {
  const [pageHeight, setPageHeight] = useState(window.innerHeight);
  const navigate = useNavigate();
  const { getFAQ } = useSelector((state) => state.FAQ);
  useEffect(() => {
    // Update the page height dynamically whenever the window is resized
    const handleResize = () => {
      setPageHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const items = [
    {
      key: '1',
      label: 'How can I advertise on the app?',
      children: (
        <p>
          -You can advertise on the app by emailing support@fanzpick.com and
          requesting access to sponsor your favorite teams.
        </p>
      ),
    },
    {
      key: '2',
      label: 'Can I advertise on more than one team page?',
      children: (
        <p>- Yes, you can advertise on as many team pages as you like.</p>
      ),
    },
    {
      key: '3',
      label: ' What is Fanzpick?',
      children: (
        <p>- Fanzpick is an app that helps aggregate fans' opinions.</p>
      ),
    },
    {
      key: '4',
      label: 'How does it work?',
      children: (
        <p>
          {' '}
          - Fanzpick allows you to visually showcase your preferred starting
          lineup and changes during a live game. Your opinions are aggregated
          with other like-minded fans, and the app creates stats to show the
          percentage of fans who agree with you and how your opinion compares to
          the manager's choices.
        </p>
      ),
    },
    {
      key: '5',
      label: ' Why can’t I give an opinion for a second team?',
      children: (
        <p>
          {' '}
          - Fanzpick encourages true fans to support only one team, which is why
          you can only give your opinion on your favorite team.
        </p>
      ),
    },
    {
      key: '6',
      label: 'Can I change my favourite team?',
      children: <p> - Who changes teams??? Come on!!! </p>,
    },
    {
      key: '7',
      label: 'Can I share it with friends?',
      children: (
        <p>
          {' '}
          - Yes, you can share your selections on major social platforms through
          the app's share option.
        </p>
      ),
    },
    {
      key: '8',
      label: 'What does the hairdryer icon represent?',
      children: (
        <p>
          {' '}
          - The hairdryer icon represents voicing disapproval towards a player's
          performance.
        </p>
      ),
    },
    {
      key: '9',
      label: 'What does the star icon represent?',
      children: (
        <p>
          {' '}
          - The star icon is used to praise a player who you believe is
          performing the best at any point.
        </p>
      ),
    },
    {
      key: '10',
      label: 'Can I give a star and hairdryer to more than one player?',
      children: (
        <p>
          {' '}
          - No, you can only select one player for the star and hairdryer icons
          at any given point. However, you can move the icons throughout a live
          game as many times as you like.
        </p>
      ),
    },
    {
      key: '11',
      label: ' Why can’t I select certain players for certain positions?',
      children: (
        <p>
          {' '}
          - Fanzpick has an algorithm that restricts certain players from being
          selected for positions they would never play in, ensuring accurate and
          realistic choices.
        </p>
      ),
    },
    {
      key: '12',
      label: ' There are players missing from the squad list, why is that?',
      children: (
        <p>
          {' '}
          - Squad names and fixture lists are sourced from a third-party API
          feed. If data is missing or inaccurate, you can send your feedback to
          support@fanzpick.com to improve the app's experience.
        </p>
      ),
    },
  ];
  const onChange = (key) => {
    console.log(key);
  };

  return (
    <React.Fragment>
      <div className={styles.contactUs}>
        <h1>Contact Us</h1>
        <Link
          to={'#'}
          onClick={(e) => {
            window.location.href = 'mailto:support@fanzpick.com';
            e.preventDefault();
          }}
        >
          Support@fanzpick.com
        </Link>
      </div>

      <h1>Frequently Asked Questions</h1>
      <div className={styles.data}>
        <Collapse items={items} defaultActiveKey={['1']} onChange={onChange} />
      </div>
    </React.Fragment>

    // <div dangerouslySetInnerHTML={{ __html: getFAQ?.data?.content }} />
  );
}

export default Faq;
